import { CheckIcon } from "@phosphor-icons/react/dist/csr/Check";
import { ChatMarkdown } from "@/core/components/chat-markdown";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { ChatTypingDots } from "./chat-typing-dots";

interface LiveAssistantMessageProps {
  displayedLiveText: string;
  progressSteps: string[];
}

export const LiveAssistantMessage = ({
  displayedLiveText,
  progressSteps,
}: LiveAssistantMessageProps) => (
  <div className="mt-6 w-full min-w-0">
    {!displayedLiveText && progressSteps.length === 0 && <ChatTypingDots />}
    {progressSteps.length > 0 && (
      <Stack
        align="start"
        gap={1}
        className={cn({
          "mb-3": displayedLiveText,
        })}
      >
        {progressSteps.map((step, index) => {
          const isCurrent =
            index === progressSteps.length - 1 && !displayedLiveText;

          return (
            <div key={`${step}-${index}`} className="flex items-center gap-1.5">
              <span className="flex size-4 shrink-0 items-center justify-center">
                {isCurrent ? (
                  <span className="size-1.5 rounded-full bg-accent-teal-bold motion-safe:animate-pulse" />
                ) : (
                  <CheckIcon className="size-3 text-success" />
                )}
              </span>
              <span
                className={cn("text-sm", {
                  "text-ink": isCurrent,
                  "text-subtle": !isCurrent,
                })}
              >
                {step}
              </span>
            </div>
          );
        })}
      </Stack>
    )}
    {displayedLiveText && (
      <ChatMarkdown streaming>{displayedLiveText}</ChatMarkdown>
    )}
  </div>
);
